<template>
    <div class="clearfix rounded pb-5 mx-auto">
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">PF Settings<span>
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / PF Settings</span>
        </h4>
        <div class="ibox mt-4">
            <div class="">
                <form enctype="multipart/form-data" @submit.stop.prevent="formSubmit">
                    <div v-if="$acl['company/savepfsettings'] > 0" id="pf_settings">
                        {{ successmsg }}
                        <div class="clearfix row no-margin ibox-content">
                            <div class="col-md-12 fixed-section-one mb-4">
                                <div class="clearfix approval-container row">
                                    <div class="col-4 approve-level-label">
                                        <div class="approve-level-title">
                                            PF Settings
                                        </div>
                                        <div class="approve-level-description">
                                            The PF Settings
                                            allows for configuring multiple functions of Provident Fund module
                                            including the monthly contribution percentage on the salary component of
                                            an employee, the Fiscal Year period, visual representations, Profit
                                            Distribution methods, and controlling waivers and audit features.
                                        </div>
                                    </div>
                                    <div class="col-8 approve-level-content">
                                        <div class="clearfix px-0 border-bottom">
                                            <div class="clearfix">
                                                <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin" v-if="settings_pf_type == 0">
                                                    <div class="col-md-9 px-0 salary-heads">Enable Provident Fund
                                                        <b-icon icon="info-circle" title="Enable Provident Fund" v-b-tooltip></b-icon>
                                                    </div>
                                                    <div class="col-md-3 text-right">
                                                        <toggle-button v-model="company_reg_enable" key="company_reg_enable" value="true" :sync="true" :color="{ checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" /> <!-- Mustafijur: 24-06-2026: Checked color to #004242 -->
                                                    </div>
                                                </div>

                                                <div class="row mx-1 py-2 w-100 align-items-center no-margin form-group px-4" v-if="settings_pf_type == 0">
                                                    <!-- Company Contribution -->
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <label class="mr-0 col-form-label" style="margin-top: 6px;">Please enter % of company contribution*</label>
                                                        <b-form-input id="company_registered_provident_fund_value" name="company_registered_provident_fund_value" key="company_registered_pf" v-model="company_reg_pf" v-validate="{ required: false, max_value: 20, decimal: 2 }" :state="validateState('company_registered_provident_fund_value')" aria-describedby="company_registered_provident_fund_value-feedback" data-vv-as="Registered provident fund contribution of Company" :disabled="!company_reg_enable"></b-form-input>
                                                        <b-form-invalid-feedback id="company_registered_provident_fund_value">{{ veeErrors.first('company_registered_provident_fund_value') }}</b-form-invalid-feedback>
                                                    </div>

                                                    <!-- Employee Contribution -->
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <label class="mr-0 col-form-label" style="margin-top: 6px;">Please enter % of employee contribution*</label>
                                                        <b-form-input id="employee_registered_provident_fund_value" name="employee_registered_provident_fund_value" key="employee_registered_pf" v-model="employee_reg_pf" v-validate="{ required: false, max_value: 20, decimal: 2 }" :state="validateState('employee_registered_provident_fund_value')" aria-describedby="employee_registered_provident_fund_value-feedback" data-vv-as="Registered provident fund contribution of Employee" :disabled="!company_reg_enable"></b-form-input>
                                                        <b-form-invalid-feedback id="employee_registered_provident_fund_value">{{ veeErrors.first('employee_registered_provident_fund_value') }}</b-form-invalid-feedback>
                                                    </div>

                                                    <!-- Contribution Applied On -->
                                                    <div class="col-md-6 pl-0 align-bottom">
                                                        <label class="ml-0 col-form-label" style="margin-top: 6px;">Contribution applied on</label>
                                                        <b-form-group id="reg-pf-group" label="" class="required-field custom-select-arrow text-right mb-0" label-for="reg_pf_based_on">
                                                            <b-form-select id="reg_pf_based_on" name="reg_pf_based_on" v-model="pf_on" v-validate="{ required: true }" :options="pf_bases" :class="{ 'inactive-select-arraow': !company_reg_enable }" :disabled="!company_reg_enable"></b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                </div>

                                                <!-- PF Fund Fiscal Year End -->
                                                <div class="row mx-1 mt-1 py-2 w-100 align-items-center no-margin form-group px-4" v-if="settings_pf_type == 0">
                                                    <div class="col-md-6 pl-0">
                                                        <label class="ml-0 col-form-label" style="margin-top: 6px;">PF Fund Fiscal Year End <b-icon class="" icon="info-circle" title="Select PF Fund Fiscal Year End Month" v-b-tooltip></b-icon></label>
                                                        <b-form-group id="reg-pf-fiscal-group" label="" class="required-field custom-select-arrow text-right mb-0" label-for="reg_pf_year_end">
                                                            <b-form-select id="reg_pf_year_end" name="reg_pf_year_end" v-model="pf_year_end" v-validate="{ required: true }" :options="m_lists" :class="{ 'inactive-select-arraow': !company_reg_enable }" :disabled="!company_reg_enable"></b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-md-6 pl-0">
                                                        <label class="ml-0 col-form-label" style="margin-top: 6px;">Employer PF Taxability</label>
                                                        <b-form-group id="employer-pf-taxability-group" label="" class="required-field custom-select-arrow text-right mb-0" label-for="employer_pf_taxability">
                                                            <b-form-select id="employer_pf_taxability" name="employer_pf_taxability"
                                                                v-model="employer_pf_taxability" v-validate="{ required: true }"
                                                                :options="employer_pf_taxability_arr"></b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                
                                                <!-- Provident Fund Bulk Upload -->
                                                <!-- <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin">
                                                    <div class="col-md-9 px-0 salary-heads">Provident Fund Bulk Upload
                                                    </div>
                                                    <div class="col-md-3 text-right px-0">
                                                        <toggle-button v-model="pf_bulk_upload" key="pf_bulk_upload" value="true" :sync="true" :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />
                                                    </div>
                                                </div> -->
                                                
                                                <!-- Provident Fund API -->
                                                <!-- <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin">
                                                    <div class="col-md-9 px-0 salary-heads">Provident Fund API
                                                    </div>
                                                    <div class="col-md-3 text-right px-0">
                                                        <toggle-button v-model="pf_api" key="pf_api" value="true" :sync="true" :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>

                                        <div class="clearfix rounded px-0 service_length_settings">
                                            <div class="border-bottom pb-3 row">
                                                <div class="col-md-6">
                                                    <p class="service_length_title salary-heads">Service length format settings <b-icon class="" icon="info-circle" title="Service length will show on all reports and slips in selected format" v-b-tooltip></b-icon></p>
                                                    <div class="mt-3">
                                                        <div class="toggle_button_tax first salary-heads d-flex">
                                                            <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Only Months</div>
                                                            <div class="trz_service_button px-0 cmp-child-items text-right">
                                                                <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                    <input data-v-25adc6c0="" type="radio" v-model="company_pf_service_month" class="v-switch-input trz_tax_radio" name="company_pf_service_month" value="no">
                                                                    <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px; background-color: rgb(227, 52, 47); border-radius: 11px;">
                                                                        <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="toggle_button_tax first salary-heads d-flex">
                                                            <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Year and Months</div>
                                                            <div class="trz_service_button px-0 cmp-child-items text-right">
                                                                <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                    <input data-v-25adc6c0="" type="radio" v-model="company_pf_service_month" class="v-switch-input trz_tax_radio" name="company_pf_service_month" value="yes">
                                                                    <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px; background-color: rgb(227, 52, 47); border-radius: 11px;">
                                                                        <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="ibox no-shadow border-2 mt-4 gray-border col-md-6">
                                                    <b-overlay rounded="sm" class='payslip-designer-overlay'>
                                                        <div class="clearfix service_format_overview mb-3 mt-2 mx-auto px-3 py-4">
                                                            <div class="number_format_header_title font-medium" style="font-size: 18px;color: #747474;">Sample Output</div>
                                                            <table style="width: 99%;" class="d-table">
                                                                <template v-if="company_pf_service_month == 'no'">
                                                                    <tr>
                                                                        <td class='service_format_overview_td_label py-2 text-secondary border-bottom'>Service Period</td>
                                                                        <td class='service_format_overview_td_value border-bottom py-2'>47 Month(s)</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class='service_format_overview_td_label text-secondary py-2'>Membership Period</td>
                                                                        <td class='service_format_overview_td_value py-2'>11 Month(s)</td>
                                                                    </tr>
                                                                </template>
                                                                <template v-if="company_pf_service_month == 'yes'">
                                                                    <tr>
                                                                        <td class='service_format_overview_td_label py-2 text-secondary border-bottom'>Service Period</td>
                                                                        <td class='service_format_overview_td_value py-2 border-bottom'>3 Year(s) 11 Month(s)</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td class='service_format_overview_td_label text-secondary py-2'>Membership Period</td>
                                                                        <td class='service_format_overview_td_value py-2'>0 Year(s) 11 Month(s)</td>
                                                                    </tr>
                                                                </template>
                                                            </table>
                                                        </div>
                                                    </b-overlay>
                                                </div>
                                            </div>

                                            <!-- <p class="service_length_title salary-heads" v-if="investment_feature == 0">Profit Distribution Settings -->
                                            <p class="service_length_title salary-heads" v-if="!addons.includes('PfInvestment')">Profit Distribution Settings
                                                <b-icon class="" icon="info-circle" title="Profit wil distribute according to the selected type" v-b-tooltip></b-icon>
                                            </p>
                                            <!-- <div class="toggle_button_tax first salary-heads d-flex" v-if="investment_feature == 0"> -->
                                            <div class="toggle_button_tax first salary-heads d-flex" v-if="!addons.includes('PfInvestment')">
                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Equal Distribution</div>
                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                        <input data-v-25adc6c0="" type="radio" v-model="company_pf_profit_distribute_type" class="v-switch-input trz_tax_radio" name="profit_distribute_settings" value="equal">
                                                        <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px; background-color: rgb(227, 52, 47); border-radius: 11px;">
                                                            <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- <div class="toggle_button_tax first salary-heads d-flex" v-if="investment_feature == 0"> -->
                                            <div class="toggle_button_tax first salary-heads d-flex" v-if="!addons.includes('PfInvestment')">
                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Cumilitive Distribution</div>
                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                        <input data-v-25adc6c0="" type="radio" v-model="company_pf_profit_distribute_type" class="v-switch-input trz_tax_radio" name="profit_distribute_settings" value="cumilitive">
                                                        <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px; background-color: rgb(227, 52, 47); border-radius: 11px;">
                                                            <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>

                                            <!-- <div class="toggle_button_tax first salary-heads d-flex" v-if="investment_feature == 0">
                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Weighted Average
                                                </div>
                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                        <input data-v-25adc6c0="" type="radio" v-model="company_pf_profit_distribute_type" class="v-switch-input trz_tax_radio" name="profit_distribute_settings" value="weighted_average">
                                                            <div data-v-25adc6c0="" class="v-switch-core"
                                                            style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                                            <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div> -->

                                            <!-- <div class="toggle_button_tax first salary-heads d-flex">
                                                <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Weighted Average</div>
                                                <div class="trz_service_button px-0 cmp-child-items text-right">
                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                        <input data-v-25adc6c0="" type="radio" v-model="company_pf_profit_distribute_type" class="v-switch-input trz_tax_radio" name="profit_distribute_settings" value="cumilitive">
                                                        <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px; background-color: rgb(227, 52, 47); border-radius: 11px;">
                                                            <div data-v-25adc6c0="" class="v-switch-button"></div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div> -->

                                           <!-- Advance Send To Bank -->
                                         <!-- Start: Rejwan: 24-08-2026 -->
                                            <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin border-bottom">
                                                <div class="col-md-9 px-0 salary-heads">PF Advance Send To Bank
                                                </div>
                                                <div class="col-md-3 text-right px-0">
                                                    <toggle-button v-model="pf_advance_awaiting_disbursement" key="pf_advance_awaiting_disbursement" value="true" :sync="true" :color="{ checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />
                                                </div>
                                            </div>

                                            <!-- Settlement Send To Bank -->
                                            <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin border-bottom">
                                                <div class="col-md-9 px-0 salary-heads">PF Settlement Send To Bank
                                                </div>
                                                <div class="col-md-3 text-right px-0">
                                                    <toggle-button v-model="pf_settlement_awaiting_disbursement" key="pf_settlement_awaiting_disbursement" value="true" :sync="true" :color="{ checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />
                                                </div>
                                            </div>
                                            <!-- //    End: Rejwan: 24-08-2026 -->

                                            <!-- Profit Distribution Bulk Upload -->
                                            <!-- <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin" v-if="investment_feature == 0"> -->
                                            <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin border-bottom" v-if="!addons.includes('PfInvestment')"> <!-- //    Start: Rejwan: 24-08-2026 -->
                                                <div class="col-md-9 px-0 salary-heads">Profit Distribution Bulk Upload
                                                </div>
                                                <div class="col-md-3 text-right px-0">
                                                    <toggle-button v-model="profit_distribution_bulk_upload" key="profit_distribution_bulk_upload" value="true" :sync="true" :color="{ checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" /> <!-- //    Start: Rejwan: 24-08-2026 -->
                                                </div>
                                            </div>

                                            <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin border-bottom" v-if="settings_pf_type == 0">
                                                <div class="col-md-9 px-0 salary-heads">PF Profit Waiver Feature
                                                    <b-icon class="" icon="info-circle" title="If enabled employees will be able to waive their claim on PF Profit/Interest" v-b-tooltip></b-icon>
                                                </div>
                                                <div class="col-md-3 text-right px-0">
                                                    <toggle-button v-model="company_pf_profit_waive_feature" key="company_pf_profit_waive_feature" value="true" :sync="true" :color="{ checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" /> <!-- Mustafijur: 24-06-2026: Checked color to #004242 -->
                                                </div>
                                            </div>

                                            <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin" v-if="settings_pf_type == 0">
                                                <div class="col-md-9 px-0 salary-heads">PF Profit Audit Feature
                                                    <b-icon class="" icon="info-circle" title="If enabled no profit/interest will be allocated to employee until audit" v-b-tooltip></b-icon>
                                                </div>
                                                <div class="col-md-3 text-right px-0">
                                                    <toggle-button v-model="company_pf_profit_audit_feature" key="company_pf_profit_audit_feature" value="true" :sync="true" :color="{ checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />  <!-- Mustafijur: 24-06-2026: Checked color to #004242 -->
                                                </div>
                                            </div>

                                            <!-- Investment Feature -->
                                            <!-- <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin border-bottom" v-if="settings_pf_type == 0 && addons.includes('PfInvestment')">
                                                <div class="col-md-9 px-0 salary-heads">Investment Feature
                                                    <b-icon class="" icon="info-circle" title="If enabled employees will be able to see the Investment Features" v-b-tooltip></b-icon>
                                                </div>
                                                <div class="col-md-3 text-right px-0">
                                                    <toggle-button v-model="investment_feature" key="investment_feature" value="true" :sync="true" :color="{ checked: '#004242', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />
                                                </div>
                                            </div> -->

                                            <!-- Bot Management -->
                                            <!-- <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin border-bottom" v-if="settings_pf_type == 0">
                                                <div class="col-md-9 px-0 salary-heads">BoT Management
                                                    <b-icon class="" icon="info-circle" title="If enabled employees will be able to see the BoT Management" v-b-tooltip></b-icon>
                                                </div>
                                                <div class="col-md-3 text-right px-0">
                                                    <toggle-button v-model="bot_management_feature" key="bot_management_feature" value="true" :sync="true" :color="{ checked: '#38c172', unchecked: '#e3342f', disabled: '#CCCCCC' }" v-validate="{ required: false }" />
                                                </div>
                                            </div> -->
                                        </div>


                                        <div class="clearfix approval-container row bg-white">
                                            <div class="col-4">
                                                <div class="approve-level-title">
                                                    Decimal Places
                                                </div>
                                            </div>
                                            <div class="col-8 approve-level-content py-4 ">
                                                <div class="clearfix rounded px-0 service_length_settings">
                                                    <p class="service_length_title salary-heads">Please select your desired option <b-icon class="" icon="info-circle" title="Service length will show on all reports and slips in selected format" v-b-tooltip></b-icon></p>

                                                    <div class="pl-5">
                                                        <div class="toggle_button_tax first salary-heads d-flex">
                                                            <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>2 decimal places</div>
                                                            <div
                                                                class="trz_service_button px-0 cmp-child-items text-right">
                                                                <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                    <input data-v-25adc6c0="" type="radio"
                                                                        v-model="decimal_point_settings"
                                                                        class="v-switch-input trz_tax_radio"
                                                                        name="decimal_point_settings" value="yes">
                                                                    <div data-v-25adc6c0="" class="v-switch-core"
                                                                        style="width: 50px; height: 22px;  background-color: #CC5057;  border-radius: 11px;">
                                                                        <div data-v-25adc6c0=""
                                                                            class="v-switch-button radio_btn_whitedote">
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div class="toggle_button_tax first salary-heads d-flex">
                                                            <div class="cmp-child-items"><span class="cmp-outer-circle mr-2"><span class="cmp-inner-circle"></span></span>Rounded to closest integer.</div>
                                                            <div
                                                                class="trz_service_button px-0 cmp-child-items text-right">
                                                                <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                    <input data-v-25adc6c0="" type="radio" v-model="decimal_point_settings" class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="no">
                                                                    <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: #CC5057;  border-radius: 11px;">
                                                                        <div data-v-25adc6c0=""
                                                                            class="v-switch-button radio_btn_whitedote">
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <template v-if="decimal_point_settings == 'no'">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="card text-left mb-4 mt-3 gray-border no-shadow border-2 radius-8">
                                                                <div class="card-body">
                                                                    <div class="row ">
                                                                        <div
                                                                            class="col-md-12 d-flex justify-content-center flex-column border-bottom">
                                                                            <h5 class="mb-2 ">Rounding to the Nearest Integer</h5>
                                                                            <p class="mb-4 text-secondary">The most common type of rounding is to round to the nearest integer. The rule for rounding is simple; look at the digits in the tenth's place (the first digit to the right of the decimal point). If the digit in the tenths place is less than 5, then <strong>round down</strong>, which means the units digit remains the same: When digit in the tenths place is 5 or greater, then
                                                                            <strong>round up</strong>, which means you should increase the unit digit by one.</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mt-4">
                                                                        <div class="col-md-3 text-right"><b-icon icon="exclamation-triangle" style="width: 90px; height: 90px;" variant="danger" class="align-custom"></b-icon></div> <!--Mustafijur: 24-06-2026: col-md-2 to col-md-3 -->
                                                                        <div
                                                                            class="col-md-9 d-flex justify-content-center flex-column"> <!--Mustafijur: 24-06-2026: col-md-10 to col-md-9 -->
                                                                            <h5 class="mb-2 text-danger">Disclaimer</h5>
                                                                            <p class="mb-0 text-secondary mb-4">Please note rounding of figures may result in nominal differences due to the impact of fractions. AccordHRM will not be responsible for any under or over deductions and/or payments due to such differences.</p> <!--Mustafijur: 24-06-2026: ATL HR to AccordHRM -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>

                                                </template>
                                            </div>
                                        </div>
                                        <div class="row mx-1 mt-3 py-2 w-100 align-items-center no-margin" v-if="$acl['company/savepfsettings'] > 1">
                                            <div class="col-sm-12 text-right mt-4">
                                                <button type="submit" class="btn btn-primary btn-md">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['companyid'],
    data() {
        return {
            company_reg_pf: 0,
            employee_reg_pf: 0,
            pf_on: 1,
            pf_bases: [
                { value: "1", text: "Basic Salary" },
                { value: "2", text: "Gross Salary" },
            ],
            m_lists: [
                { value: '1', text: 'January' }, { value: '2', text: 'February' },
                { value: '3', text: 'March' }, { value: '4', text: 'April' },
                { value: '5', text: 'May' }, { value: '6', text: 'June' },
                { value: '7', text: 'July' }, { value: '8', text: 'August' },
                { value: '9', text: 'September' }, { value: '10', text: 'October' },
                { value: '11', text: 'November' }, { value: '12', text: 'December' }
            ],
            pf_year_end: 6,
            company_reg_enable: false,
            company_pf_settings: [],
            company_id: this.companyid,
            successmsg: '',
            settings_pf_type: 0,
            company_pf_profit_waive_feature: false,
            company_pf_profit_audit_feature: false,
            company_pf_service_month: 'no',
            company_pf_profit_distribute_type: 'equal',
            movenext: false,
            pf_bulk_upload: false,
            pf_api: false,
            profit_distribution_bulk_upload: false,
            // investment_feature: false,
            bot_management_feature: false,
            decimal_point_settings:'no',
            pf_advance_awaiting_disbursement: false,
            pf_settlement_awaiting_disbursement: false,
            employer_pf_taxability_arr: [{
                    value: "1",
                    text: "Yes"
                },
                {
                    value: "2",
                    text: "No"
                },
            ],

            employer_pf_taxability: 1,
            addons: [],
        }
    },
    watch: {
    // investment_feature(val) {
    //         if (!val) {
    //             this.profit_distribution_bulk_upload = false;
    //         }
    //     }
    },
    methods: {
        getCompanyData() {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/company/details').then(response => {
                if (response.data.length != 0) {
                    this.addons  = response.data.module_disabled;
                }
            });
        },
        showMessage() {
            let childdata = { movenext: this.movenext };
            this.$emit('childToParent', childdata);
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        getcompany() {
            let formData = new FormData();
            axios.post(this.$api_url + '/company/getcompany', formData)
                .then(function (response) {
                    this.company_id = response.data;
                    if (this.company_id > 0) {
                        this.getCompanyPFSettings();
                    }
                }.bind(this));
        },
        getCompanyPFSettings() {
            let formData = new FormData();
            axios.post(this.$api_url + '/pf/settings', formData)
                .then(function (response) {
                    if (response.data.data) {
                        this.company_pf_settings = response.data.data;
                        this.settings_pf_type = parseInt(this.company_pf_settings.pf_type.opt_value);
                        this.pf_on = (parseInt(this.company_pf_settings.pf_applied_on.opt_value) > 0)
                            ? parseInt(this.company_pf_settings.pf_applied_on.opt_value) : 2;

                        if (this.settings_pf_type !== 1) {
                            this.company_reg_pf = this.company_pf_settings.company_pf_contribution.opt_value !== '0'
                                ? this.company_pf_settings.company_pf_contribution.opt_value : null;
                            this.employee_reg_pf = this.company_pf_settings.employee_pf_contribution.opt_value !== '0'
                                ? this.company_pf_settings.employee_pf_contribution.opt_value : null;
                            // this.company_reg_enable = parseInt(this.company_pf_settings.company_pf_contribution.status) === 1;
                            this.company_reg_enable = this.company_pf_settings.pf_enabled.opt_value;
                            this.company_pf_profit_audit_feature = parseInt(this.company_pf_settings.pf_profit_audit_feature.opt_value) === 1;
                            this.company_pf_profit_waive_feature = parseInt(this.company_pf_settings.pf_profit_waive_feature.opt_value) === 1;
                            this.company_pf_service_month = parseInt(this.company_pf_settings.pf_service_month_format.opt_value) === 1 ? 'yes' : 'no';
                            this.company_pf_profit_distribute_type = this.company_pf_settings.pf_profit_distribute_type.opt_value;
                            this.pf_year_end = this.company_pf_settings.pf_year_end.opt_value == 0
                                ? 6 : this.company_pf_settings.pf_year_end.opt_value;
                            this.pf_bulk_upload = parseInt(this.company_pf_settings.pf_bulk_upload.opt_value) === 1;
                            this.pf_api = parseInt(this.company_pf_settings.pf_api.opt_value) === 1;
                            this.profit_distribution_bulk_upload = parseInt(this.company_pf_settings.profit_distribution_bulk_upload.opt_value) === 1;
                            this.pf_advance_awaiting_disbursement = parseInt(this.company_pf_settings.pf_advance_awaiting_disbursement.opt_value) === 1;
                            this.pf_settlement_awaiting_disbursement = parseInt(this.company_pf_settings.pf_settlement_awaiting_disbursement.opt_value) === 1;
                            // this.investment_feature = parseInt(this.company_pf_settings.investment_feature.opt_value) === 1;
                            this.bot_management_feature = parseInt(this.company_pf_settings.bot_management_feature.opt_value) === 1;
                            this.decimal_point_settings = this.company_pf_settings.decimal_point_settings.opt_value;

                            const employer_pf_taxability_val = this.company_pf_settings.employer_pf_taxability.opt_value;
                            this.employer_pf_taxability = (employer_pf_taxability_val == 0 || employer_pf_taxability_val == null) ? 1 : employer_pf_taxability_val;
                            // console.log('this.company_pf_settings.employer_pf_taxability.opt_value: ' + this.company_pf_settings.employer_pf_taxability.opt_value);
                        }
                    }
                }.bind(this));
        },
        formSubmit(e) {
            e.preventDefault();

            let formData = new FormData();
            const config = { headers: { 'content-type': 'multipart/form-data' } };

            formData.append('settings', 1); // 1 for general settings
            formData.append('company_id', this.company_id);
            formData.append('company_pf_type', this.settings_pf_type);
            formData.append('company_pf_on', this.pf_on);
            formData.append('company_pf_year_end', this.pf_year_end);
            formData.append('pf_profit_distribute_type', this.company_pf_profit_distribute_type);
            formData.append('pf_service_month_format', this.company_pf_service_month === 'no' ? 0 : 1);
            formData.append('company_pf_profit_audit_feature', this.company_pf_profit_audit_feature ? 1 : 0);
            formData.append('company_pf_profit_waive_feature', this.company_pf_profit_waive_feature ? 1 : 0);
            formData.append('pf_bulk_upload', this.pf_bulk_upload ? 1 : 0);
            formData.append('pf_api', this.pf_api ? 1 : 0);
            formData.append('profit_distribution_bulk_upload', this.profit_distribution_bulk_upload ? 1 : 0);
            formData.append('pf_advance_awaiting_disbursement', this.pf_advance_awaiting_disbursement ? 1 : 0);
            formData.append('pf_settlement_awaiting_disbursement', this.pf_settlement_awaiting_disbursement ? 1 : 0);
            // formData.append('investment_feature', this.investment_feature ? 1 : 0);
            formData.append('bot_management_feature', this.bot_management_feature ? 1 : 0);
            formData.append('decimal_point_settings', this.decimal_point_settings);
            formData.append('employer_pf_taxability', this.employer_pf_taxability);
            
            let pf_status = this.company_reg_enable ? 1 : 0;

            if (pf_status) {
                if (!parseFloat(this.company_reg_pf) > 0 || !parseFloat(this.employee_reg_pf) > 0) {
                    this.$bvToast.toast('Please select valid Contribution Percentage', { title: 'Error!', variant: 'danger', solid: true });
                    return false;
                }
            }

            formData.append('company_pf_percentage', this.company_reg_pf);
            formData.append('employee_pf_percentage', this.employee_reg_pf);
            formData.append('company_pf_status', pf_status);

            axios.post(this.$api_url + '/pf/settings/save', formData, config)
                .then(function (response) {
                    if (response.data.data) {
                        this.getCompanyPFSettings();
                        this.$bvToast.toast('PF Settings saved', { title: 'Success', variant: 'success', solid: true });
                        this.movenext = true;
                        this.showMessage();
                    } else {
                        this.$bvToast.toast('An error occurred, please try again later', { title: 'Error!', variant: 'danger', solid: true });
                    }
                }.bind(this))
                .catch(function (error) {
                    this.$bvToast.toast(error, { title: 'Error!', variant: 'danger', solid: true });
                }.bind(this));
        }
    },
    created() {
        this.getcompany();
        this.getCompanyData();

    }
}
</script>

<style scoped>
.trz_service_button {
    display: inline-block;
    vertical-align: top;
    padding-left: 0;
}

.service_length_title[data-v-83ba1f78] {
    margin-top: 33px;
    margin-bottom: 10px;
}

.trz_service_button .v-switch-button {
    transform: translate3d(3px, 3px, 0px);
    width: 16px;
    height: 16px;
    transition: transform 300ms ease 0s;
}

.toggle_button_tax {
    margin-bottom: 10px;
}

.service_length_settings .toggle_button_tax {
    padding: 10px 0 10px 0;
    margin: 0;
}

.toggle_button_tax.first {
    border-bottom: 1px solid #dee2e6;
}

.trz_service_button.tax_toggle {
    float: right;
}

.trz_service_button.px-0.tax_toggle {
    max-width: 50px;
}

.service_format_overview {
    margin-top: 35px;
    margin-left: 15px !important;
}

.service_format_overview_td_label {
    text-align: left !important;
    font-size: 16px !important;
    width: 45% !important;
}

.service_format_overview_td_value {
    text-align: right !important;
    font-size: 16px !important;
    width: 65% !important;
    color: #004242;
}

.number_format_header_title {
    text-align: center;
    margin-bottom: 10px;
}

.service_format_overview {
    padding: 10px 10px !important;
}

#pf_loan_applicable_percent {
    display: block !important;
}
</style>
